import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 175,
	height: 150,
	viewBox: "0 0 175 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2526 17.7266L11.2502 17.7304C10.345 19.2401 8.33869 19.7076 6.80873 18.7889C5.29229 17.8785 4.80361 15.9038 5.71393 14.3818C6.66147 12.8561 8.63997 12.374 10.1573 13.285C11.6742 14.1958 12.1618 16.2404 11.2526 17.7266Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0519 8.71131L18.0518 8.71142L18.0616 8.71724C18.9339 9.23552 19.2298 10.3988 18.6949 11.3357C18.1743 12.1782 17.0127 12.4648 16.1188 11.9373C15.2266 11.3758 14.9544 10.2379 15.4807 9.35087C16.009 8.46048 17.173 8.16164 18.0519 8.71131Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.527 125.469L40.5269 125.469L40.5367 125.475C41.409 125.993 41.7049 127.157 41.1699 128.094C40.6494 128.936 39.4878 129.223 38.5939 128.695C37.7017 128.134 37.4295 126.996 37.9558 126.109C38.4841 125.218 39.6481 124.919 40.527 125.469Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.261 90.0043L165.262 90.0043L165.262 89.9908C165.302 88.4923 166.605 87.2773 168.095 87.3578C169.594 87.4388 170.78 88.7387 170.743 90.2449C170.658 91.7438 169.357 92.9174 167.861 92.8366L167.861 92.8364L167.848 92.836C166.358 92.7958 165.18 91.5036 165.261 90.0043Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.771 103.725V31.064C158.771 23.9751 153.09 18.2091 146.073 18.2455H33.1335C26.1548 18.2455 20.4723 23.9732 20.4723 31.064V103.725C20.4723 110.778 26.1177 116.544 33.1335 116.544H146.11C153.088 116.544 158.771 110.816 158.771 103.725Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.5 129.5V116.5H108.5V129.5H73.5Z",
			fill: "#1D1D1D",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.859 135.373V140.5H59.5V135.373C59.5 131.889 62.332 129.055 65.8135 129.055H115.545C119.027 129.055 121.859 131.889 121.859 135.373Z",
			fill: "#62B5A6",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.284 29.978V101.489H29.0399V29.978C29.0399 28.1916 30.3548 26.813 31.8522 26.813H148.472C149.969 26.813 151.284 28.1916 151.284 29.978Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.267 75.4911V75.9911H124.767H130.315H130.815V75.4911V67.8714H132.677L136.782 75.7227L136.923 75.9911H137.226H143.424H144.279L143.859 75.2458L138.971 66.5582C141.266 65.2974 142.746 63.0257 142.746 59.6857C142.746 56.7558 141.661 54.7695 139.867 53.54C138.108 52.3335 135.734 51.9028 133.228 51.9028H124.767H124.267V52.4028V75.4911ZM132.794 62.5017H130.815V57.3035H132.794C134.088 57.3035 134.979 57.4832 135.538 57.8493C136.049 58.1843 136.354 58.725 136.354 59.6857C136.354 60.6532 136.041 61.3257 135.496 61.7694C134.933 62.2272 134.049 62.5017 132.794 62.5017Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.8506 63.8385C98.8506 67.7116 99.9467 70.862 101.903 73.0506C103.863 75.2446 106.647 76.425 109.918 76.425C113.19 76.425 115.974 75.2446 117.934 73.0506C119.89 70.862 120.986 67.7116 120.986 63.8385C120.986 59.9801 119.89 56.8887 117.93 54.7568C115.966 52.6209 113.183 51.5 109.918 51.5C106.655 51.5 103.872 52.6124 101.908 54.7448C99.947 56.8732 98.8506 59.9651 98.8506 63.8385ZM114.346 63.8385C114.346 66.0079 113.885 67.7285 113.106 68.8904C112.339 70.0346 111.256 70.6524 109.918 70.6524C108.581 70.6524 107.507 70.0354 106.748 68.8922C105.975 67.7303 105.522 66.0094 105.522 63.8385C105.522 61.6673 105.976 60.0056 106.742 58.9017C107.494 57.8182 108.566 57.2416 109.918 57.2416C111.272 57.2416 112.352 57.8189 113.112 58.9035C113.885 60.0075 114.346 61.6688 114.346 63.8385Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.9624 75.4911V75.9911H78.4624H84.0098H84.5098V75.4911V67.8714H86.3722L90.4777 75.7227L90.618 75.9911H90.9207H97.1189H97.974L97.5547 75.2458L92.666 66.5582C94.961 65.2974 96.4413 63.0257 96.4413 59.6857C96.4413 56.7558 95.3561 54.7695 93.5627 53.54C91.8029 52.3335 89.429 51.9028 86.9229 51.9028H78.4624H77.9624V52.4028V75.4911ZM86.489 62.5017H84.5098V57.3035H86.489C87.7833 57.3035 88.674 57.4832 89.2327 57.8493C89.7438 58.1843 90.0489 58.725 90.0489 59.6857C90.0489 60.6532 89.7366 61.3257 89.1912 61.7694C88.6285 62.2272 87.7439 62.5017 86.489 62.5017Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.0206 75.4911V75.9911H56.5206H62.068H62.568V75.4911V67.8714H64.4304L68.5359 75.7227L68.6762 75.9911H68.979H75.1772H76.0322L75.6129 75.2458L70.7243 66.5582C73.0192 65.2974 74.4995 63.0257 74.4995 59.6857C74.4995 56.7558 73.4143 54.7695 71.6209 53.54C69.8611 52.3335 67.4872 51.9028 64.9811 51.9028H56.5206H56.0206V52.4028V75.4911ZM64.5473 62.5017H62.568V57.3035H64.5473C65.8416 57.3035 66.7323 57.4832 67.2909 57.8493C67.802 58.1843 68.1071 58.725 68.1071 59.6857C68.1071 60.6532 67.7949 61.3257 67.2495 61.7694C66.6867 62.2272 65.8021 62.5017 64.5473 62.5017Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 75.4911V75.9911H37H51.9686H52.4686V75.4911V70.8424V70.3424H51.9686H43.0474V66.4459H50.2641H50.7641V65.9459V61.2972V60.7972H50.2641H43.0474V57.5205H51.6277H52.1277V57.0205V52.4028V51.9028H51.6277H37H36.5V52.4028V75.4911Z",
			fill: "#E5E7EB",
			stroke: "black"
		})
	]
});
export default SvgRetry;
